var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"50px"}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }